import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { Link, unstable_HistoryRouter, useNavigate } from 'react-router-dom'
import sha256 from 'crypto-js/sha256';
import whatsapp from '../images/whatsapp.png'
import Darkmode from '../Account/Darkmode'
import Cropper from 'react-easy-crop';
import ChangeLanguage from '../translations/ChangeLanguage';
import { useTranslation } from 'react-i18next';
import ProfileImg from '../images/ProfileImg.jpg'
import CoverImg from '../images/CoverImg.jpg'
import CoverImgMedical from '../images/medicalepicture.png'
import QRCode from 'qrcode.react';
import { saveAs } from 'file-saver';
import { HexColorPicker } from 'react-colorful';
import ReviemParametres from '../components/ReviemParametres';
import ReviewDisplay from '../components/ReviewDisplay';
import PointageUser from '../components/PointageUser';
import GoogleReview from '../components/GoogleReview';
import background from '../images/background.jpg'
import textColeur from '../images/textColeur.jpg'
import testebouton from '../images/testebouton.jpg'
import soulignement from '../images/soulignement.jpg'
import sombre from '../images/sombre.jpg'
import conteurbutton from '../images/conteurbutton.jpg'
import claire from '../images/claire.jpg'
import bgbutton from '../images/bgbutton.jpg'
import SelectSearch from './components/SelectSearch';
import UTMListAndForm from '../utm/UTMForm';
import { getProfileField } from '../translations/profileTranslation';






function ProfileInfoEdit() {
  const { t } = useTranslation();
  const apiUrl = process.env.REACT_APP_BACKEND_URL
  const ImageUrl = process.env.REACT_APP_IMAGES_URL
  const frontEndUrl = process.env.REACT_APP_REACT_URL

  const [Imagecontent, setImagecontent] = useState('')

  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');
  let IdEntreprise = Cookies.get('IdEntreprise');


  const hashedUserId = sha256((String(userId)));
  let LanguageSelected = Cookies.get('LanguageSelected');


  const secretKey = 'vcard-secret-key';

  const encryptedUserId = btoa(userId.toString() + secretKey);

  const [Done, setDone] = useState(false)
  const [InputsErrors, setInputsErrors] = useState([])


  const [OrigineCRM, setOrigineCRM] = useState(false)
  const [EditOrigineCRM, setEditOrigineCRM] = useState(false)
  const [OrigineCRMInfo, setOrigineCRMInfo] = useState({})
  const [OrigineCRMContent, setOrigineCRMContent] = useState(null)

  const [saveTheme, setSaveTheme] = useState(false)

  const [SettingPage, setSettingPage] = useState(false)
  const [UserInfo, setUserInfo] = useState(false)
  const [EditUserInfo, setEditUserInfo] = useState(false)

  const [ProfileInfo, setProfileInfo] = useState({})
  const [ProfileContent, setProfileContent] = useState(null)
  const [ProfilePhotoContent, setProfilePhotoContent] = useState(null)
  const [CoverPhotoContent, setCoverPhotoContent] = useState(null)

  const [EditDarkLight, setEditDarkLight] = useState('dark')
  const [UserEmail, setUserEmail] = useState('')




  const [CoverImageModal, setCoverImageModal] = useState(false)
  const [ProfileImageModal, setProfileImageModal] = useState(false)

  const [DetailPartageContact, setDetailPartageContact] = useState(false)
  const [PatageContactId, setPatageContactId] = useState(false)

  const [PartageContactContent, setPartageContactContent] = useState([])
  const [QrCode, setQrCode] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);

  const [PasswordChange, setPasswordChange] = useState(false)
  const [ContactPrtager, setContactPrtager] = useState(false)
  const [PasswordInfo, setPasswordInfo] = useState({})

  const [themeData, setThemeData] = useState('theme-classique');
  const [themeDone, setThemeDone] = useState(false)
  const [isFetching, setIsFetching] = useState(false);

  const [phones, setPhones] = useState([])
  const [ContactContent, setContactContent] = useState([])
  const [ListValeursEntreprise, setListValeursEntreprise] = useState([])
  const [ListValeurs, setListValeurs] = useState([])

  const [UserOrigineCrm, setUserOrigineCrm] = useState(false)
  const [SwitchThemes, setSwitchThemes] = useState(false)
  const [ColorsNewTheme, setColorsNewTheme] = useState({
    light: [
      { inner_section_backgroud: '#eaedee', css: 'inner_section_backgroud' },
      { section_background: '#ffffff', css: 'section_background' },
      { body_backgroud: '#F5F8F9', css: 'body_backgroud' },
      { text_color: '#000000', css: 'text-color' },
      { gold: '#C8A443', css: 'gold' },
      { border_bottom: '#ca9608', css: 'border-bottom' },
      { text_gold: '#C8A443', css: 'text-gold' },
      { text_color_auth: '#3f3f3f', css: 'text-color-auth' },
      { partage_bg: '#baf7ba', css: 'partage-bg' },
      { text_button: 'black', css: 'text_button' },

    ],
    dark: [
      { inner_section_backgroud: '#171718', css: 'inner_section_backgroud' },
      { section_background: '#202021', css: 'section_background' },
      { body_backgroud: '#121212', css: 'body_backgroud' },
      { text_color: '#b2b2b2', css: 'text-color' },
      { gold: '#C8A443', css: 'gold' },
      { border_bottom: '#F5F8F9', css: 'border-bottom' },
      { text_gold: '#C8A443', css: 'text-gold' },
      { text_color_auth: '#f0f0f0', css: 'text-color-auth' },
      { partage_bg: '#008000', css: 'partage-bg' },
      { text_button: 'white', css: 'text_button' },


    ]
  });

  const colorsKeys = [
    { name: 'background', background: 'inner_section_backgroud', image: background },
    { name: 'sections', sections: 'section_background', image: claire },
    { name: 'innerSections', innerSections: 'body_backgroud', image: sombre },
    { name: 'textColor', textColor: 'text-color', image: textColeur },
    { name: 'buttonColors', buttonColors: 'gold', image: bgbutton },
    { name: 'butoonBorderBottom', butoonBorderBottom: 'border-bottom', image: conteurbutton },
    { name: 'textBorderColor', textBorderColor: 'text-gold', image: soulignement },
    { name: 'authentificationTitle', authentificationTitle: 'text-color-auth', image: null },
    { name: 'cardPartageContact', cardPartageContact: 'partage-bg', image: null },
    { name: 'texButton', texButton: 'text_button', image: testebouton }

  ];


  const [ImageTheme, setImageTheme] = useState(null)
  const [ImageThemeModal, setImageThemeModal] = useState(false)


  const HandleImageTheme = (image, e) => {
    e.preventDefault();
    setImageTheme(image)
    setImageThemeModal(true)
  }




  const [ColorsNewThemeModal, setColorsNewThemeModal] = useState(false)
  const [GoogleLink, setGoogleLink] = useState(null)



  const [theme, setTheme] = useState('');
  const userToken = Cookies.get('UserSpecialToken');

  const updateThemeData = (newTheme) => {
    fetch(`${apiUrl}/UpdateThemeData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({ theme_data: newTheme, user_id: userId }),
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          console.log(result.data);
        }
      });
  };

  const setDarkMode = () => {
    document.querySelector('body').setAttribute('data-theme', 'dark');
    updateThemeData('dark');
  };

  const setLightMode = () => {
    document.querySelector('body').setAttribute('data-theme', 'light');
    updateThemeData('light');
  };

  useEffect(() => {
    fetch(`${apiUrl}/GetThemeDataProfileEdit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({ user_id: userId }),
    })
      .then(response => response.json())
      .then(result => {
        if (result.data === 'dark') {
          document.querySelector('body').setAttribute('data-theme', 'dark');
          setTheme('dark');
        } else {
          document.querySelector('body').setAttribute('data-theme', 'light');
          setTheme('light');

        }
        document.documentElement.classList.add(`${result.theme}`);



      });
  }, []);

  const toggleTheme = (theme) => {
    if (theme == 'dark') {
      setDarkMode();
      setTheme('dark');
    } else {
      setLightMode();
      setTheme('light');
    }
  };





  const handleChangeColor = (index, item, theme, e) => {
    const newColor = e.target.value;

    console.log('index, item, theme-----------', index, item, theme)

    // Update ColorsNewTheme state based on the new color
    const updatedColorsNewTheme = { ...ColorsNewTheme };
    updatedColorsNewTheme[theme][index][item[item.name]] = newColor;
    setColorsNewTheme(updatedColorsNewTheme);


    console.log('updatedColorsNewTheme-------', updatedColorsNewTheme)

  };




  const [vCardData, setVCardData] = useState(null);

  useEffect(() => {
    createVCard();
  }, [ProfileInfo, ContactContent]);




  useEffect(() => {
    fetch(`${apiUrl}/GetPasswordStatus`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })

    })
      .then(response => response.json())
      .then(result => {
        if (result.data == null) {
          setPasswordChange(true)
        }
      });
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/GetThemeClassiqueMedical`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${UserToken}`,
      },
      body: JSON.stringify({ user_id: userId }),
    })
      .then(response => response.json())
      .then(result => {
        setThemeData(result.data)
        setColorsNewTheme(result.NewTheme)
        setGoogleLink(result.googleLinkReview)
        console.log('result.NewTheme', result.NewTheme)
      });
  }, [themeDone]);


  useEffect(() => {
    // Apply dynamic CSS when colors are fetched
    if (ColorsNewTheme) {
      const rootStyle = document.documentElement.style;
      const cssText = generateCSS(ColorsNewTheme);
      const styleElement = document.createElement('style');
      styleElement.textContent = cssText;
      document.head.appendChild(styleElement);
    }
  }, [ColorsNewTheme]);

  const generateCSS = (colors) => {
    let css = '';
    colors.dark.forEach(color => {
      css += `:root.theme-personalise [data-theme="dark"]  { --${color.css}: ${color[color.css]}; }\n`;
    });
    colors.light.forEach(color => {
      css += `:root.theme-personalise { --${color.css}: ${color[color.css]}; }\n`;
    });
    return css;
  };




  useEffect(() => {
    navigate('/ProfileEdit')

    fetch(`${apiUrl}/GetProfileInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setProfileContent(result.data)
          setProfileInfo({ ...ProfileInfo, user_id: userId })
          setPasswordInfo({ ...PasswordInfo, user_id: userId })



        }
      })


    fetch(`${apiUrl}/GetPartageContactInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setPartageContactContent(result.data)
        }
      })




    fetch(`${apiUrl}/GetProfilePhoto`, {
      method: "POST",
      headers: {
        "Content-Type": "image/jpeg",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setProfilePhotoContent(data.data)
        }
      })

    fetch(`${apiUrl}/GetCoverPhoto`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setCoverPhotoContent(result.data)
        }
      })

    fetch(`${apiUrl}/GetContactInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setPhones(result.PhoneNumbers)
          setContactContent([result.data])
          console.log(phones)

        }

      })

    fetch(`${apiUrl}/GetOrigineCRMInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setOrigineCRMContent(result.data)
          console.log(result.data)
        }

      })


    fetch(`${apiUrl}/GetAllValeursEnrepriseProfile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ idEntre: IdEntreprise })
    })
      .then(response => response.json())
      .then(result => {
        setListValeursEntreprise(result.data)
      })

    fetch(`${apiUrl}/GetUserOrigineCrm`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })
    })
      .then(response => response.json())
      .then(result => {
        setUserOrigineCrm(result.data)
        setUserEmail(result.email)
      })




    fetch(`${apiUrl}/GetAllValeursProfile`, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      }
    })
      .then(response => response.json())
      .then(result => {
        setListValeurs(result.data)
      })


  }, [Done])




  const navigate = useNavigate()


  useEffect(() => {
    if (CoverImageModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [CoverImageModal]);

  useEffect(() => {
    if (ProfileImageModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [ProfileImageModal]);



  const AddingPasswordInfo = (e) => {
    return setPasswordInfo({ ...PasswordInfo, [e.target.name]: e.target.value })

  }

  const AddingProfileInfo = (e) => {
    return setProfileInfo({ ...ProfileInfo, [e.target.name]: e.target.value })

  }
  const AddingOrigineCRMInfo = (e) => {
    return setOrigineCRMInfo({ ...OrigineCRMInfo, [e.target.name]: e.target.value })

  }

  const SetOrigineCRMToUpdateDefaultValues = () => {
    const profile = OrigineCRMContent
    return setOrigineCRMInfo({ ...OrigineCRMInfo, OrigineId: profile.id, Localisation: profile.location, ville: profile.ville, Evenement: profile.event, Action: profile.action })

  }


  const SetProfileToUpdateDefaultValues = () => {
    const profile = ProfileContent
    return setProfileInfo({ ...ProfileInfo, prefixPhone: profile.prefixPhone, profileId: profile.id, firstName: getProfileField(profile, 'first_name', LanguageSelected), lastName: getProfileField(profile, 'last_name', LanguageSelected), position: getProfileField(profile, 'position', LanguageSelected), company: getProfileField(profile, 'company', LanguageSelected), phone: profile.phone })

  }
  function compressImage(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const maxWidth = 800; // Set your desired max width
          const maxHeight = 600; // Set your desired max height
          let newWidth = img.width;
          let newHeight = img.height;

          if (img.width > maxWidth || img.height > maxHeight) {
            const aspectRatio = img.width / img.height;
            if (aspectRatio > 1) {
              newWidth = maxWidth;
              newHeight = maxWidth / aspectRatio;
            } else {
              newHeight = maxHeight;
              newWidth = maxHeight * aspectRatio;
            }
          }

          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          canvas.toBlob((blob) => {
            resolve(new File([blob], file.name, { type: file.type }));
          }, file.type);
        };
      };
      reader.readAsDataURL(file);
    });
  }


  const AddingCoverImage = async (e) => {
    let CoverImage = e.target.files[0]
    if (!CoverImage) {
      toast.error('No image selected');
      return;
    }

    const allowedExtensions = ['png', 'jpg', 'jpeg', 'gif'];
    const maxSize = 20 * 1024 * 1024; // 20 MB in bytes

    const extension = CoverImage.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(extension)) {
      toast.error('Invalid image format. Allowed formats: PNG, JPG, JPEG, GIF');
      return;
    }

    if (CoverImage.size > maxSize) {
      toast.error('Image size exceeds 20 MB');
      return;
    }

    handleCoverImageCrop(e, CoverImage)
  };






  const AddingProfileImage = async (e) => {
    let ProfileImage = e.target.files[0]
    if (!ProfileImage) {
      toast.error('No image selected');
      return;
    }

    const allowedExtensions = ['png', 'jpg', 'jpeg', 'gif'];
    const maxSize = 20 * 1024 * 1024; // 20 MB in bytes

    const extension = ProfileImage.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(extension)) {
      toast.error('Invalid image format. Allowed formats: PNG, JPG, JPEG, GIF');
      return;
    }

    if (ProfileImage.size > maxSize) {
      toast.error('Image size exceeds 20 MB');
      return;
    }
    handleImageCrop(e, ProfileImage)
  };




  const textRef = useRef(null);

  const handleCopy = () => {
    const textToCopy = textRef.current.textContent;
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        toast.success('Text Copied', {
          position: toast.POSITION.CENTER
        });

      })
      .catch((error) => {
        console.error('Error copying text:', error);
      });
  };


  const StoreOrigineCRMInfo = (e) => {
    e.preventDefault()
    setIsFetching(true);
    axios
      .post(`${apiUrl}/StoreOrigineCRMInfo`, OrigineCRMInfo, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      })
      .then(result => {
        if (result.data.success) {
          setOrigineCRMInfo({})
          setDone(!Done)
          setInputsErrors([])
          setOrigineCRM(false)
          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }



  const UpdateOrigineCRMInfo = (e) => {
    e.preventDefault()
    setIsFetching(true);
    axios
      .post(`${apiUrl}/UpdateOrigineCRMInfo`, OrigineCRMInfo, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      })
      .then(result => {
        if (result.data.success) {
          setOrigineCRMInfo({})
          setDone(!Done)
          setInputsErrors([])
          setEditOrigineCRM(false)
          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)
        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }





  const StoreProfileInfo = (e) => {
    e.preventDefault()
    setIsFetching(true);
    axios
      .post(`${apiUrl}/StoreProfileInfo`, { ...ProfileInfo, lang: LanguageSelected }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      })
      .then(result => {
        if (result.data.success) {
          setProfileInfo('')
          setDone(!Done)
          setInputsErrors([])
          setImagecontent('')
          setUserInfo(false)
          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)
        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }
  const DeleteCoverImage = (e) => {
    e.preventDefault()



    axios
      .post(`${apiUrl}/DeleteCoverImage`, { User_id: userId }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      })
      .then(result => {
        if (result.data.success) {
          setProfileInfo('')
          setDone(!Done)
          setInputsErrors([])
          setUserInfo(false)
          setCoverImageModal(false)
          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)

        }
      })


  }

  const DeleteProfileImage = (e) => {
    e.preventDefault()



    axios
      .post(`${apiUrl}/DeleteProfileImage`, { User_id: userId }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      })
      .then(result => {
        if (result.data.success) {
          setProfileInfo('')
          setDone(!Done)
          setInputsErrors([])
          setUserInfo(false)
          setProfileImageModal(false)
          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)

        }
      })


  }
  const UpdateProfileInfo = (e) => {
    e.preventDefault()

    setIsFetching(true);


    axios
      .post(`${apiUrl}/UpdateProfileInfo`, { ...ProfileInfo, lang: LanguageSelected }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      })
      .then(result => {
        if (result.data.success) {
          setProfileInfo('')
          setInputsErrors([])
          setImagecontent('')
          setDone(!Done)
          setEditUserInfo(false)
          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }


  const UpdateThemeClassiqueMedical = (newTheme) => {
    setIsFetching(true)
    fetch(`${apiUrl}/UpdateThemeClassiqueMedical`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${UserToken}`,
      },
      body: JSON.stringify({ theme_info: newTheme, user_id: userId, colorsData: ColorsNewTheme }),
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setThemeDone(!themeDone)
          document.documentElement.className = result.theme;
          setSaveTheme(false)
          setIsFetching(false)
          toast.success('theme updated successfully', {
            position: toast.POSITION.TOP_CENTER
          });
        }


      });
  };

  const HandleLogOut = () => {
    fetch(`${apiUrl}/LogOut`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`

      },
    })
      .then(response => response.json())
      .then(result => {
        navigate(`/Profile/${encryptedUserId}`)


        Cookies.remove('userId');
        Cookies.remove('UserSpecialToken');

        window.location.reload()



        toast.success(result.message, {
          position: toast.POSITION.BOTTOM_CENTER
        });

      })
  }




  const ChangePassword = (e) => {
    setIsFetching(true);

    e.preventDefault()
    fetch(`${apiUrl}/ChangePassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify(PasswordInfo)
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setPasswordInfo('')
          setDone(!Done)
          setPasswordChange(false)
          toast.success(result.message, {
            position: toast.POSITION.CENTER
          });

        }
        else if (result.success == false) {
          setInputsErrors(result.errors)


        }
      })
      .finally(() => {
        setIsFetching(false);
      });

  }


  const handleProfileImage = async (e, CroppedImage) => {
    e.preventDefault()

    const croppedImageBase64 = await convertBlobToBase64(CroppedImage);


    axios
      .post(`${apiUrl}/handleProfileImage`, { croppedImage: croppedImageBase64 }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      })
      .then(result => {
        if (result.data.success) {
          setInputsErrors([])
          setImagecontent('')
          setDone(!Done)
          setCropProfileImage(false)
          setCroppedImage(null);
          setImageToCrop(null);

          setZoom(1)
          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)
          if (result.data.errors) {

            result.data.errors.croppedImage.map(error => {
              toast.error(error, {
                position: toast.POSITION.CENTER
              });
            })
          }



        }
      })
  }



  const handleCoverImage = async (e, CroppedImage) => {


    const croppedImageBase64 = await convertBlobToBase64(CroppedImage);


    e.preventDefault()
    axios
      .post(`${apiUrl}/handleCoverImage`, { CoverImage: croppedImageBase64 }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${UserToken}`,
        },
      })
      .then(result => {
        if (result.data.success) {
          setInputsErrors([])
          setImagecontent('')
          setCoverImageModal(false)
          setCropCoverImage(false)
          setDone(!Done)
          setZoom(1)

          toast.success(result.data.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.data.errors)
          if (result.data.errors) {
            result.data.errors.CoverImage.map(error => {
              toast.error(error, {
                position: toast.POSITION.CENTER
              });
            })
          }
        }
      })
  }
  const DeletePartageContactInfo = (e, id) => {
    e.preventDefault()

    fetch(`${apiUrl}/DeletePartageContactInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ PartageId: id })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setDone(!Done)

        }
      })
  }

  const [CropProfileImage, setCropProfileImage] = useState(false);
  const [CropCoverImage, setCropCoverImage] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (CropProfileImage || ContactPrtager || CropCoverImage || EditUserInfo || UserInfo || SettingPage || ProfileImageModal || CoverImageModal || QrCode) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [CropProfileImage, ContactPrtager, CropCoverImage, EditUserInfo, UserInfo, SettingPage, ProfileImageModal, QrCode, CoverImageModal]);



  const [imageToCrop, setImageToCrop] = useState(null);

  const onCropChange = (crop) => {
    setCrop(crop);
  };

  const onZoomChange = (zoom) => {
    setZoom(zoom);
  };



  const handleImageCrop = (e, fileImage) => {
    const file = fileImage;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageToCrop(reader.result);
      };
      reader.readAsDataURL(file);
    }

    // Set state to control UI, like showing cropped image or closing modal

    setCropProfileImage(true);
    setProfileImageModal(false);
  };


  const handleCoverImageCrop = (e, fileImage) => {
    const file = fileImage;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageToCrop(reader.result);
      };
      reader.readAsDataURL(file);
    }

    // Set state to control UI, like showing cropped image or closing modal

    setCropCoverImage(true);
    setCoverImageModal(false);
  };

  const handleCropComplete = async (_, croppedAreaPixels) => {
    try {
      const croppedImageBlob = await getCroppedImageBlob(imageToCrop, croppedAreaPixels);
      const compressedFile = await compressImage(croppedImageBlob);
      setCroppedImage(compressedFile);
    } catch (error) {
      console.error('Error cropping image:', error);
    }
  };
  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  };

  const getCroppedImageBlob = (imageSrc, croppedAreaPixels) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = imageSrc;
      const canvas = document.createElement('canvas');
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;
      const ctx = canvas.getContext('2d');

      image.onload = () => {
        ctx.drawImage(
          image,
          croppedAreaPixels.x,
          croppedAreaPixels.y,
          croppedAreaPixels.width,
          croppedAreaPixels.height,
          0,
          0,
          croppedAreaPixels.width,
          croppedAreaPixels.height
        );
        canvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/jpeg');
      };
    });
  };

  const SavedContact = () => {
    fetch(`${apiUrl}/SavedContact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ PartageId: PatageContactId })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setDone(!Done)
          toast.success(result.message, {
            position: toast.POSITION.CENTER
          });
        }
        else {
          setInputsErrors(result.errors)
        }
      })
  }



  const makeVCard = () => {
    const contact = PartageContactContent.find(contact => contact.id === PatageContactId)

    const email = contact?.email
    const name = contact?.first_name + ' ' + contact?.last_name || null;
    const org = contact?.company || null;
    const title = contact?.position || null;
    const tel = contact?.prefixPhone + contact?.phone || null;
    const address = contact?.location || null;
    const preview = 'https://unsplash.com/s/photos/photo';

    const vCardData = `BEGIN:VCARD
VERSION:3.0
N:${name};;;;
FN:${name}
ORG:${org}
TITLE:${title}
TEL:${tel}
ADR:${address}
EMAIL:${email}
PHOTO:${preview}
END:VCARD`;

    const blob = new Blob([vCardData], { type: 'text/vcard' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${name}.vcf`;
    link.click();
    URL.revokeObjectURL(url);

    SavedContact()

  };



  const fetchImageDataURL = async () => {
    try {
      const response = await fetch(`${apiUrl}/images/${hashedUserId}/${ProfilePhotoContent}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      return data.imageDataUrl;
    } catch (error) {
      console.error('Error fetching image Data URL:', error);
      return null;
    }
  };

  // Function to convert Blob to Base64
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(blob);
    });
  };



  const createVCard = async () => {
    const email = ContactContent[0]?.email || '';
    const firstName = getProfileField(ProfileContent, 'first_name', LanguageSelected);
    const lastName = getProfileField(ProfileContent, 'last_name', LanguageSelected);
    const org = getProfileField(ProfileContent, 'company', LanguageSelected);
    const title = getProfileField(ProfileContent, 'position', LanguageSelected);
    const address = ContactContent[0]?.location || '';
    const phoneNumbers = phones || [];
    const photoUrl = null;

    let vCardData = `BEGIN:VCARD\nVERSION:3.0`;

    if (firstName || lastName) {
      vCardData += `\nN:${lastName};${firstName};;;`;
    }
    if (firstName && lastName) {
      vCardData += `\nFN:${firstName} ${lastName}`;
    } else {
      vCardData += `\nFN:${firstName || lastName}`;
    }

    if (org) vCardData += `\nORG:${org}`;
    if (title) vCardData += `\nTITLE:${title}`;
    if (address) vCardData += `\nADR:${address}`;
    if (email) vCardData += `\nEMAIL:${email}`;

    phoneNumbers.forEach(phoneObj => {
      const { phone, prefixPhone } = phoneObj;
      const formattedPhoneNumber = `${prefixPhone}-${phone}`;
      vCardData += `\nTEL:${formattedPhoneNumber}`;
    });

    let imageBase64 = '';

    if (photoUrl) {
      try {
        const response = await fetch(photoUrl);
        const imageBlob = await response.blob();
        imageBase64 = await blobToBase64(imageBlob);
      } catch (error) {
        console.error('Error fetching or encoding image:', error);
      }
    }

    if (imageBase64) {
      vCardData += `\nPHOTO;TYPE=JPEG;ENCODING=b:${imageBase64}`;
    }

    vCardData += `\nEND:VCARD`;
    setVCardData(vCardData);
  };




  const themesInfo = [
    { name: 'Theme classique', color: 'bg-', value: 'theme-classique' },
    { name: 'Theme vert', color: '', value: 'theme-medical' },
    { name: 'Theme violet', color: '', value: 'theme-violet' },
    { name: 'Theme rouge', color: '', value: 'theme-rouge' },
    { name: 'Theme orange', color: '', value: 'theme-orange' },
    { name: 'Theme blue', color: '', value: 'theme-blue' },
    { name: 'Theme rose', color: '', value: 'theme-rose' },
    { name: 'Theme jaune', color: '', value: 'theme-jaune' },
    { name: 'Theme personalise', color: '', value: 'theme-personalise' },




  ]

  const ParametreValue = (id) => {
    const valueObject = ListValeurs.find(item => item.id == id)
    if (valueObject) {
      return valueObject.value

    }

  }
  const status = Cookies.get('UserStatus');



  return (
    <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>
      <section className="relative header   pt-3">



        <div className="relative p-3    pb-4">

          <div className="z-50 w-full   h-90  mx-auto sections rounded-xl shadow-md pb-5">
            <div className='relative '>

              <ChangeLanguage />
              <div className='h-64 relative div-sections cover_image  rounded-t-xl'>
                <Darkmode />


                <img className="cover w-full  h-full rounded-t-xl mx-auto" src={CoverPhotoContent ? `${ImageUrl}/${hashedUserId}/${CoverPhotoContent}` : CoverImg} alt="Profile picture" />


              </div>

              <a onClick={() => setCoverImageModal(true)}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-8 h-8 sections  rounded-lg p-0.5 font-bold absolute right-2 bottom-2"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                </svg>
              </a>





            </div>


            <div className='relative  flex justify-center mx-auto' style={{ width: '175px' }}>
              <img className="relative z-10  profile_photo  cover " src={ProfilePhotoContent ? `${ImageUrl}/${hashedUserId}/${ProfilePhotoContent}` : ProfileImg} alt="Profile picture" />
              <a onClick={() => setProfileImageModal(true)}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-8 h-8 sections  rounded-lg  p-0.5 text-bold  absolute  z-50 bottom-2  right-4">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                </svg>
              </a>


            </div>
            <div className="text-center m-3">
              {ProfileContent != null &&
                <>
                  <h3 className="title title--h3  sidebar__user-name text-theme  pb-1"><span className="weight--500">{getProfileField(ProfileContent, 'first_name', LanguageSelected)}</span> {getProfileField(ProfileContent, 'last_name', LanguageSelected)}</h3>

                  {ProfileContent.position != null &&

                    <div className="div-sections rounded-xl flex-wrap items-center justify-center p-1">
                      <p className='font-semibold text-theme text-2xl'>{getProfileField(ProfileContent, 'position', LanguageSelected)}</p>
                      <p className='text-about text-theme text-xl'>{getProfileField(ProfileContent, 'company', LanguageSelected)}</p>
                    </div>

                  }
                </>
              }
            </div>
          </div>
        </div>

        <div className="w-full  grid grid-cols-2 pl-3 pb-0.5 pr-3 gap-3 mx-auto ">

          {ProfileContent == null ?
            <button onClick={() => { setUserInfo(true) }} className="btn-edit ">
              {t('Ajouter Profile')}
            </button>
            :
            <button onClick={() => { setEditUserInfo(true); SetProfileToUpdateDefaultValues() }} className=" btn-edit  ">
              {t('Modifier Profile')}
            </button>
          }
          <button onClick={() => { setSettingPage(true) }} className="btn-edit ">
            {t('Paramètres')}
          </button>



        </div>

      </section>
      <div className='w-full grid grid-cols-2 pt-3 pl-3 pb-0.5 pr-3 gap-3 mx-auto'>
        <button onClick={() => { setContactPrtager(true) }} type="submit" className="w-full btn-edit">

          {t('Liste Contacts')}

        </button>
        <button onClick={() => { setQrCode(true) }} type="submit" className="w-full btn-edit">

          {t('QR code')}


        </button>
      </div>

      <div className={`w-full grid ${IdEntreprise && IdEntreprise !== 'null' && IdEntreprise !== 'undefined' ? 'grid-cols-2' : 'grid-cols-1'} pt-3 pl-3 pb-0.5 pr-3 gap-3 mx-auto`}>
        <ReviewDisplay />

        <PointageUser />
      </div>

      <div className="w-full grid grid-cols-1 pt-3 pl-3 pb-0.5 pr-3 gap-3 mx-auto ">


        <UTMListAndForm />
        {/* <button onClick={() => { setSettingPage(true) }} className="btn-edit ">
            {t('Utms')}
          </button> */}




      </div>

      <div className='w-full grid grid-cols-1 pt-3 pl-3 pb-0.5 pr-3 gap-3 mx-auto'>
        {UserOrigineCrm == true &&
          <div>
            {OrigineCRMContent == null ?
              <button onClick={() => { setOrigineCRM(true) }} type="submit" className="w-full btn-edit">

                {t('Origine CRM')}


              </button>
              :
              <button onClick={() => { setEditOrigineCRM(true); SetOrigineCRMToUpdateDefaultValues() }} type="submit" className="w-full btn-edit">

                {t('Origine CRM')}


              </button>
            }
          </div>
        }
      </div>

      {OrigineCRM &&

        <div>

          <div className="minscreen h-full animated  overflow-auto fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info overflow">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => {
                setOrigineCRM(false); setInputsErrors([]);
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme  cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl text-theme mb-2">{t("Origine CRM")}</h2>
              <h2 className="textModal mb-6">{t("Complétez les informations d'Origine CRM")}
              </h2>
              <form className="space-y-5 text-about">

                <div>
                  <div className="mt-4">
                    <input onChange={(e) => AddingOrigineCRMInfo(e)} type="text" id="Localisation" name="Localisation" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Localisation")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Localisation') && InputsErrors.Localisation}</span></p>

                  </div>
                </div>

                <SelectSearch
                  ListValeurs={ListValeurs}
                  ListValeursEntreprise={ListValeursEntreprise}
                  OrigineCRMContent={OrigineCRMContent}
                  AddingOrigineCRMInfo={AddingOrigineCRMInfo}
                  ParametreValue={ParametreValue}
                  OrigineCRMInfo={OrigineCRMInfo}
                  InputsErrors={InputsErrors}
                  LanguageSelected={LanguageSelected}
                />



                <div className='btn-pass'>


                  <button onClick={(e) => StoreOrigineCRMInfo(e)} disabled={isFetching} type="submit" className="w-full btn-edit">
                    {t("enregistrer")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>


      }

      {EditOrigineCRM &&

        <div className=''>

          <div className="minscreen h-screen overflow-auto animated fadeIn faster   fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => {
                setEditOrigineCRM(false); setInputsErrors([]);
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl text-theme mb-2">{t("Origine CRM")}</h2>
              <h2 className="textModal mb-6">{t("Modifier les informations d'Origine CRM")}
              </h2>
              <form className="space-y-5 text-about">

                <div>
                  <div className="mt-4">
                    <input defaultValue={OrigineCRMContent.location} onChange={(e) => AddingOrigineCRMInfo(e)} type="text" id="Localisation" name="Localisation" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Localisation")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Localisation') && InputsErrors.Localisation}</span></p>

                  </div>
                </div>
                <SelectSearch
                  ListValeurs={ListValeurs}
                  ListValeursEntreprise={ListValeursEntreprise}
                  OrigineCRMContent={OrigineCRMContent}
                  AddingOrigineCRMInfo={AddingOrigineCRMInfo}
                  ParametreValue={ParametreValue}
                  OrigineCRMInfo={OrigineCRMInfo}
                  InputsErrors={InputsErrors}
                  LanguageSelected={LanguageSelected}

                />



                <div className='btn-pass'>


                  <button onClick={(e) => UpdateOrigineCRMInfo(e)} disabled={isFetching} type="submit" className="w-full btn-edit">
                    {t("enregistrer")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>


      }



      {UserInfo &&

        <div>

          <div className="minscreen h-full animated  overflow-auto fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info overflow">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => {
                setUserInfo(false); setInputsErrors([]);
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme  cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl text-theme mb-2">{t("Carte de contact")}</h2>
              <h2 className="textModal mb-6">{t("Complétez les informations de votre profil")}
              </h2>
              <form className="space-y-5 text-about">
                <div className="flex gap-3">
                  <div>
                    <div className="mt-4">
                      <input onChange={(e) => AddingProfileInfo(e)} type="text" id="firstName" name="firstName" className="appearance-none block placeholder-sm w-full px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black  focus:outline-none active  sm:text-sm" placeholder={t("Prenom")} required />
                      <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('firstName') && InputsErrors.firstName}</span></p>

                    </div>
                  </div>
                  <div>
                    <div className="mt-4">
                      <input onChange={(e) => AddingProfileInfo(e)} type="text" id="lastName" name="lastName" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Nom")} required />
                      <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('lastName') && InputsErrors.lastName}</span></p>

                    </div>
                  </div>
                </div>
                <div>
                  <div className="mt-4">
                    <input onChange={(e) => AddingProfileInfo(e)} type="text" id="company" name="company" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Nom d'entreprise")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('company') && InputsErrors.company}</span></p>

                  </div>
                </div>
                <div>
                  <div className="mt-7">
                    <input onChange={(e) => AddingProfileInfo(e)} type="text" id="position" name="position" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Poste")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('position') && InputsErrors.position}</span></p>

                  </div>
                </div>




                <div className='btn-pass'>


                  <button onClick={(e) => StoreProfileInfo(e)} disabled={isFetching} type="submit" className="w-full btn-edit">
                    {t("enregistrer")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>


      }

      {EditUserInfo &&

        <div className=''>

          <div className="minscreen h-screen overflow-auto animated fadeIn faster   fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => {
                setEditUserInfo(false); setInputsErrors([]);
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl text-theme mb-2">{t("Carte de contact")}</h2>
              <h2 className="textModal mb-6">{t("Modifier les informations de votre profil")}
              </h2>

              <form className="space-y-5 text-about">
                <div className="flex gap-3">
                  <div>
                    <div className="mt-4">
                      <input defaultValue={getProfileField(ProfileContent, 'first_name', LanguageSelected)} onChange={(e) => AddingProfileInfo(e)} type="text" id="firstName" name="firstName" className="appearance-none block placeholder-sm w-full px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black  focus:outline-none active  sm:text-sm" placeholder={t("Prenom")} required />
                      <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('firstName') && InputsErrors.firstName}</span></p>

                    </div>
                  </div>
                  <div>
                    <div className="mt-4">
                      <input defaultValue={getProfileField(ProfileContent, 'last_name', LanguageSelected)} onChange={(e) => AddingProfileInfo(e)} type="text" id="lastName" name="lastName" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Nom")} required />
                      <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('lastName') && InputsErrors.lastName}</span></p>

                    </div>
                  </div>
                </div>
                <div>
                  <div className="mt-4">
                    <input defaultValue={getProfileField(ProfileContent, 'company', LanguageSelected)} onChange={(e) => AddingProfileInfo(e)} type="text" id="company" name="company" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Nom d'entreprise")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('company') && InputsErrors.company}</span></p>

                  </div>
                </div>
                <div>
                  <div className="mt-7">
                    <input defaultValue={getProfileField(ProfileContent, 'position', LanguageSelected)} onChange={(e) => AddingProfileInfo(e)} type="text" id="position" name="position" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Poste")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('position') && InputsErrors.position}</span></p>

                  </div>
                </div>




                <div className='btn-pass'>



                  <button onClick={(e) => UpdateProfileInfo(e)} disabled={isFetching} type="submit" className="w-full btn-edit">
                    {t("enregistrer")}

                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>


      }
      {SettingPage &&

        <div>
          <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setSettingPage(false) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full text-about settingswidth p-8">
              <div className="flex flex-col items-left justify-start mt-8">
                <p className="text-3xl text-gold mb-5 mt-5 font-bold">{t("Paramètres")}</p>
              </div>

              <div className='w-full'>

                <button onClick={() => { setPasswordChange(true) }} type="submit" className=" w-full mb-5 flex justify-start items-center mt-5 p-3 py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium font-semibold text-theme sections h-16  hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 ml-3' : 'w-6 mr-3'}`}>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z" />
                  </svg>
                  {t("Changer le mot de passe")}


                </button>



                <div className="relative flex items-center mt-1 justify-start pl-3 rounded sections  text-theme">
                  <Link to={`${frontEndUrl}/Profile/${encryptedUserId}`} className='ml-1'>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 mr-5' : 'w-6 mr-3'}`}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                    </svg>
                  </Link>
                  <p className={`${LanguageSelected == 'ar' ? 'truncate w-44 float-right text-sm font-medium font-semibold text-theme mb-5 mt-5 mr-3' : 'truncate w-44  text-sm font-medium font-semibold text-theme mb-5 mt-5 mr-5'}`} ref={textRef}>{frontEndUrl}/Profile/{encryptedUserId}</p>

                  <svg onClick={handleCopy} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 h-6 absolute left-4' : 'w-6 h-6 absolute right-4'}`}>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />
                  </svg>




                  <a href={`https://api.whatsapp.com/send?text=${encodeURIComponent(`${frontEndUrl}/Profile/${encryptedUserId}`)}`}>
                    <img className={`${LanguageSelected == 'ar' ? 'w-6 h-6 absolute left-11 top-5' : 'w-6 h-6 absolute right-10 top-5'}`} src={whatsapp} alt />
                  </a>

                </div>

                <div className='relative flex items-center mt-3 gap-5'>

                </div>
                <button onClick={(e) => { setSwitchThemes(true) }} type="submit" className="w-full font-semibold relative text-theme flex justify-start items-center mt-3 p-3 py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium text-black sections h-16  hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 ml-3' : 'w-6 mr-3'}`}>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42" />
                  </svg>

                  {t("Changer Themes")}

                </button>


                <ReviemParametres email={UserEmail} />

                <GoogleReview link={GoogleLink} setDone={setDone} Done={Done} />



                <button onClick={(e) => { HandleLogOut(e) }} type="submit" className="w-full font-semibold relative text-theme flex justify-start items-center mt-3 p-3 py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium text-black sections h-16  hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 ml-3' : 'w-6 mr-3'}`}>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
                  </svg>
                  {t("Se déconnecter")}

                </button>
              </div>

            </div>
          </div>
        </div>


      }

      {SwitchThemes &&


        <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
          <div className="relative max-h-screen findservice overflow-hidden -mt-10 rounded-xl  sections">
            <div className="absolute -top-2 -right-2 p-4">
              <a className='w-12 h-12' onClick={() => { setSwitchThemes(false) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="pl-3 pr-3  pb-3">
              <div className={`${LanguageSelected == 'ar' ? 'pl-6' : 'pr-6'}`} >
                <div className="flex flex-col items-left justify-start ">
                  <p className="text-2xl text-gold m-3 font-bold">{t("Changer Themes")}</p>
                </div>

                <div className='grid gap-3 px-3 py-5 '>

                  {themesInfo &&
                    themesInfo.map((theme, index) => (
                      <div className={`form-control ${theme.value == 'theme-personalise' ? ' flex justify-between items-center w-full' : ''}`} key={index}>
                        <label className="label cursor-pointer flex gap-5 justify-start items-center">
                          <input
                            type="radio"
                            onChange={() => UpdateThemeClassiqueMedical(theme.value)}
                            name="themes"
                            value={theme.value}
                            checked={themeData === theme.value}
                            className="radio checked:bg-red-500"
                          />
                          <span className="label-text text-theme text-lg font-normal">{theme.name}</span>
                        </label>
                        {theme.value == 'theme-personalise' &&
                          <a onClick={() => { setColorsNewThemeModal(true); UpdateThemeClassiqueMedical('theme-personalise') }} >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                              <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                            </svg>

                          </a>
                        }

                      </div>
                    ))}







                </div>



              </div>
            </div>
          </div>
        </div>


      }
      {ColorsNewThemeModal &&

        <div>
          <div className="minscreen h-screen overflow-auto animated fadeIn faster  w-full fixed  left-0 top-0 flex justify-center items-start inset-0 z-50 forms-info  overflow-y-auto">
            <div className="absolute top-0 right-0 m-2">
              <a className='w-10 h-10' onClick={() => { setColorsNewThemeModal(false) }} >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>


            <div className=" settingswidth p-4 grid place-items-start gap-3 mt-2">
              <div className="flex flex-col items-left justify-start mt-8 ">
                <p className="text-2xl text-gold font-bold">{t("Personalise Themes")} ({theme})</p>
              </div>

              <div className="grid place-items-center grid-cols-2 gap-3 w-full">
                <button onClick={(e) => { toggleTheme('light') }} type="submit" className={` ${theme == 'light' ? 'btn-check  flex gap-2 border-color-500 border-2 mr-3 text-theme w-full m-3' : 'm-3 mr-3 w-full btn-edit'}  `}>
                  {theme == 'light' &&
                    <div className='bg-green-500 rounded-full p-1 '>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-4 h-4 text-white ">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                      </svg>
                    </div>

                  }

                  {t("light mode")}
                </button>
                <button onClick={(e) => { toggleTheme('dark') }} type="submit" className={` ${theme == 'dark' ? 'btn-check  flex gap-2 border-color-500 border-2 mr-3 text-theme w-full m-3' : 'm-3 mr-3 w-full btn-edit'}  `}>
                  {theme == 'dark' &&
                    <div className='bg-green-500 rounded-full p-1 '>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-4 h-4 text-white ">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                      </svg>
                    </div>

                  }
                  {t("dark mode")}
                </button>
              </div>

              <div className='mx-auto cursor-pointer flex w-full max-w-lg flex-col gap-2 items-center  div-sections  text-center'>
                {theme == 'dark' &&
                  colorsKeys.map((item, index) => {
                    return (
                      <div className={`w-full ${!item.image ? 'hidden' : ''}  rounded-md sections  flex justify-between items-center px-4 py-3 `}>
                        <div className='flex justify-start items-center gap-2'>
                          <a onClick={(e) => HandleImageTheme(item.image, e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-theme">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
                            </svg>

                          </a>
                          <p className='text-theme fo text-lg'>{t(item.name)} </p>
                        </div>
                        <div>
                          <input
                            type="color"
                            defaultValue={ColorsNewTheme['dark'][index][item[item.name]]}
                            onChange={(e) => handleChangeColor(index, item, 'dark', e)}
                            className=" h-9 w-12 block  cursor-pointer rounded disabled:opacity-50 disabled:pointer-events-none "
                            id="hs-color-input"
                            title="Choose your color"
                          />
                        </div>
                      </div>
                    )
                  })

                }
                {theme == 'light' &&
                  colorsKeys.map((item, index) => {
                    return (
                      <div className={`w-full ${!item.image ? 'hidden' : ''}  rounded-md sections  flex justify-between items-center px-4 py-3 `}>
                        <div className='flex justify-start items-center gap-2'>
                          <a onClick={(e) => HandleImageTheme(item.image, e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-theme">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
                            </svg>

                          </a>
                          <p className='text-theme fo text-lg'>{t(item.name)} </p>
                        </div>
                        <div>
                          <input
                            type="color"
                            onChange={(e) => handleChangeColor(index, item, 'light', e)}
                            defaultValue={ColorsNewTheme['light'][index][item[item.name]]}
                            className=" h-9 w-12 block  cursor-pointer rounded disabled:opacity-50 disabled:pointer-events-none "
                            id="hs-color-input"
                            title="Choose your color"
                          />
                        </div>
                      </div>
                    )
                  })

                }
              </div>

              <button onClick={(e) => setSaveTheme(true)} type="submit" className={`w-full  btn-edit`}>
                {t('enregistrer')}
              </button>

            </div>
          </div>
        </div>


      }

      {
        ImageThemeModal &&
        <div
          className="fixed z-1000 left-0 top-0 flex h-screen w-screen items-center justify-center bg-black bg-opacity-50 py-10"
        >
          <div className="relative max-h-screen  findservice overflow-hidden">
            <div className="absolute top-4 right-0 p-4">
              <a
                className='w-12 h-12 '
                onClick={() => {
                  setImageThemeModal(false);
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white div-sections opacity-50 rounded-xl cursor-pointer"
                  viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className='w-full pl-3 pr-3 h-fit mx-auto'>
              <img
                className="cover w-full h-full preview-image   rounded-xl mt-4"
                src={ImageTheme}
                alt="Mountain"
              />
            </div>
          </div>
        </div>
      }

      {saveTheme &&
        <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
          <div className="relative h-fit overflow-y-auto findservice  -mt-10 rounded-xl   sections">
            <div className='px-3 ' >
              <div className="flex  items-center justify-center ">
                <p className="text-xl text-theme text-center m-3 font-normal">{t("are you sure you want to save this theme")} </p>
              </div>


              <div className="grid place-items-center grid-cols-2 gap-3 w-full px-3">
                <button onClick={(e) => setSaveTheme(false)} type="submit" className="m-3 hover:scale-1.1  mr-3 w-full btn-edit">


                  {t("close")}
                </button>
                <button onClick={(e) => UpdateThemeClassiqueMedical(themeData)} disabled={isFetching} type="submit" className="m-3  mr-3 w-full btn-edit">
                  {isFetching ?
                    (<svg class="w-4 h-4 text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none"
                      xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                      <path
                        d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                        stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                      <path
                        d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                        stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-900">
                      </path>
                    </svg>)
                    : (
                      t('enregistrer')
                    )
                  }

                </button>
              </div>



            </div>



          </div>
        </div>
      }


      {ContactPrtager &&

        <div>
          <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setContactPrtager(false) }} >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full settingswidth p-8">
              <div className="flex flex-col items-left justify-start mt-8">
                <p className="text-2xl text-gold mb-5 mt-5 font-bold">{t("Liste Contacts")}</p>
              </div>

              <div>


                {
                  PartageContactContent.length > 0 ? (
                    PartageContactContent.map((contact) => (

                      <div
                        key={contact.id}
                        className={`relative w-full mb-5 flex justify-start items-center mt-5 p-3 py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium font-semibold text-theme ${contact.saved == 'saved' ? 'bg-green-400' : 'sections'} h-16 hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          className={`${LanguageSelected == 'ar' ? 'w-7 ml-3' : 'w-7 mr-3'}`}
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                          />
                        </svg>
                        <p className='text-about '>{contact.first_name} {contact.last_name}</p>


                        <a
                          onClick={() => {
                            setDetailPartageContact(true);
                            setPatageContactId(contact.id);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            className={`${LanguageSelected == 'ar' ? 'w-6 h-6 absolute top-5 left-3' : 'w-6 h-6 absolute top-5 right-3'}`}
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                            />
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                        </a>
                        <a
                          onClick={(e) => {
                            DeletePartageContactInfo(e, contact.id);
                          }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 h-6  absolute top-5 left-9' : 'w-6 h-6 absolute top-5 right-9'}`}  >


                            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                          </svg>

                        </a>
                      </div>
                    ))
                  ) : (
                    <div>
                      <h2 className="text-2xl text-about mb-6">{t("Il n'y a aucun contact partagé.")}</h2>
                    </div>
                  )
                }







              </div>

            </div>
          </div>
        </div>


      }
      {QrCode &&

        <div>
          <div className="minscreen h-screen overflow-auto animated fadeIn faster   fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setQrCode(false) }} >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full settingswidth p-8 flex flex-wrap items-center">

              <div className='w-full bg-white pt-10 pl-10 pr-10 pb-3 opacity-90 shadow rounded-xl '>
                <div className='flex justify-center items-center w-full'>
                  <QRCode value={vCardData || ''} size={250} />
                </div>
                <div className='flex justify-center items-center w-full'>
                  <h3 style={{ fontSize: '26px' }} className="title title--h3 mt-4 2-name text-black   pb-1">@<span className="weight--500">{getProfileField(ProfileContent, 'first_name', LanguageSelected)}</span> {getProfileField(ProfileContent, 'last_name', LanguageSelected)}</h3>
                </div>
              </div>

            </div>
          </div>
        </div>


      }

      {DetailPartageContact &&

        PartageContactContent.map(contact => {
          if (contact.id == PatageContactId) {
            return (
              <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
                <div className="relative max-h-screen findservice overflow-hidden -mt-10 rounded-xl  sections">
                  <div className="absolute -top-2 -right-2 p-4">
                    <a className='w-12 h-12' onClick={() => { setDetailPartageContact(false) }}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                      </svg>
                    </a>
                  </div>
                  <div className="pl-3 pr-3  pb-3">
                    <div className={`${LanguageSelected == 'ar' ? 'pl-6' : 'pr-6'}`} >
                      <div className="flex flex-col items-left justify-start ">
                        <p className="text-2xl text-gold m-3 font-bold">{t("contacts_share")}</p>
                      </div>

                      <div className="grid  px-4 py-4">
                        {contact.utm_id && (
                          <div className="mb-6 rounded-xl border border-theme/20 bg-theme/5 p-4">
                            <p className="mb-3 text-lg font-bold text-theme">
                              {t("utm_information")}

                            </p>

                            <div className="flex flex-wrap gap-2">
                              {contact.utm_source && (
                                <span className="rounded-full bg-blue-100 px-3 py-1 text-sm font-semibold text-blue-700">
                                  {t("utm_source")}: {contact.utm_source}
                                </span>
                              )}
                              {contact.utm_medium && (
                                <span className="rounded-full bg-green-100 px-3 py-1 text-sm font-semibold text-green-700">
                                  {t("utm_medium")}: {contact.utm_medium}
                                </span>
                              )}
                              {contact.utm_campaign && (
                                <span className="rounded-full bg-purple-100 px-3 py-1 text-sm font-semibold text-purple-700">
                                  {t("utm_campaign")}: {contact.utm_campaign}
                                </span>
                              )}
                              {contact.utm_term && (
                                <span className="rounded-full bg-orange-100 px-3 py-1 text-sm font-semibold text-orange-700">
                                  {t("utm_term")}: {contact.utm_term}
                                </span>
                              )}
                              {contact.utm_content && (
                                <span className="rounded-full bg-pink-100 px-3 py-1 text-sm font-semibold text-pink-700">
                                  {t("utm_content")}: {contact.utm_content}
                                </span>
                              )}
                              {contact.utm_action && (
                                <span className="rounded-full bg-red-100 px-3 py-1 text-sm font-semibold text-red-700">
                                  {t("utm_action")}: {contact.utm_action}
                                </span>
                              )}
                            </div>

                          </div>
                        )}


                        <p className=" text-theme text-base font-extrabold mb-3">{t("Prenom")} : <span className=" text-theme text-about   mb-3">{contact.first_name}</span> </p>
                        <p className=" text-theme font-bold text-base mb-3">{t("Nom")} : <span className=" text-theme text-about mb-3">{contact.last_name}</span> </p>
                        {contact.email != null &&
                          <p className=" text-theme font-bold text-base mb-3">{t("Email")} : <span className=" text-theme text-about mb-3">{contact.email}</span> </p>

                        }
                        {contact.company &&
                          <p className=" text-theme font-bold  text-base mb-3">{t("Entreprise")} : <span className=" text-theme text-about mb-3">{contact.company}</span> </p>

                        }
                        {contact.position &&
                          <p className=" text-theme font-bold  text-base mb-3">{t("Position")} : <span className=" text-theme text-about mb-3">{contact.position}</span> </p>

                        }
                        {contact.prefixPhone && contact.phone &&
                          <p className=" text-theme font-bold text-base mb-3">{t("Telephone")} : <span className=" text-theme text-about mb-3">{contact.prefixPhone}-{contact.phone}</span> </p>

                        }
                        {contact.location &&
                          <p className=" text-theme font-bold  text-base mb-3">{t("Localisation")} : <span className=" text-theme text-about mb-3">{contact.location}</span> </p>

                        }
                        {contact.event &&
                          <p className=" text-theme font-bold  text-base mb-3">{t("Evenement")} : <span className=" text-theme text-about mb-3">{ParametreValue(contact.event)}</span> </p>

                        }
                        {contact.action &&
                          <p className=" text-theme font-bold  text-base mb-3">{t("Action")} : <span className=" text-theme text-about mb-3">{ParametreValue(contact.action)}</span> </p>

                        }
                        {contact.ville &&
                          <p className=" text-theme font-bold  text-base mb-3">{t("Ville")} : <span className=" text-theme text-about mb-3">{ParametreValue(contact.ville)}</span> </p>

                        }

                      </div>

                      <div className='-mt-4'>
                        {contact.phone && contact.prefixPhone &&

                          <button onClick={(e) => { makeVCard(); setPatageContactId(contact.id) }} type="submit" className="m-3  mr-3 w-full btn-edit">
                            <i className="fas fa-address-book text-white mr-3 ml-3 mt-1" />
                            {t("Ajouter aux Contacts")}
                          </button>
                        }
                      </div>



                    </div>
                  </div>
                </div>
              </div>
            )
          }
        })


      }
      {PasswordChange &&
        <div>
          <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setPasswordChange(false) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full settingswidth p-8">
              <div className="flex flex-col items-center mt-8">
                <p className="text-2xl text-gold mb-5 mt-5">{t("Changement de mot de passe")}</p>


              </div>


              <form className="space-y-4 text-about">

                <div className="relative">
                  <div className="mt-5 mb-2 flex items-center">
                    <input onChange={(e) => { AddingPasswordInfo(e) }} type={showPassword ? 'text' : 'password'} id="password" name="current_password" className=" block w-full placeholder-sm bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Enter votre ancien mot de passe")} required />
                    {
                      showPassword == false &&
                      <svg onClick={() => setShowPassword(!showPassword)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 h-6 absolute left-4' : 'w-6 h-6 absolute right-4'}`}>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>

                    }
                    {
                      showPassword == true &&
                      <svg onClick={() => setShowPassword(!showPassword)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 h-6 absolute left-4' : 'w-6 h-6 absolute right-4'}`}>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                      </svg>

                    }


                  </div>

                  <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('current_password') && InputsErrors.current_password}</span></p>


                  <div className="mt-5 mb-2 flex items-center">
                    <input onChange={(e) => { AddingPasswordInfo(e) }} type={showPassword2 ? 'text' : 'password'} id="password" name="new_password" className=" block w-full placeholder-sm bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer votre nouveau mot de passe")} required />
                    {
                      showPassword2 == false &&
                      <svg onClick={() => setShowPassword2(!showPassword2)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 h-6 absolute left-4' : 'w-6 h-6 absolute right-4'}`}>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>

                    }
                    {
                      showPassword2 == true &&
                      <svg onClick={() => setShowPassword2(!showPassword2)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 h-6 absolute left-4' : 'w-6 h-6 absolute right-4'}`}>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                      </svg>

                    }


                  </div>


                  <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('new_password') && InputsErrors.new_password}</span></p>




                  <div className="mt-5 flex items-center">
                    <input onChange={(e) => { AddingPasswordInfo(e) }} type={showPassword3 ? 'text' : 'password'} id="password" name="confirm_password" className=" block w-full placeholder-sm bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("confirmer votre mot de passe")} required />
                    {
                      showPassword3 == false &&
                      <svg onClick={() => setShowPassword3(!showPassword3)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 h-6 absolute left-4' : 'w-6 h-6 absolute right-4'}`}>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>

                    }
                    {
                      showPassword3 == true &&
                      <svg onClick={() => setShowPassword3(!showPassword3)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 h-6 absolute left-4' : 'w-6 h-6 absolute right-4'}`}>
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                      </svg>

                    }



                  </div>
                  <p className="mt-2 mb-3 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('confirm_password') && InputsErrors.confirm_password}</span></p>

                </div>
                <div className='btn-pass' >
                  <button onClick={(e) => { ChangePassword(e) }} disabled={isFetching} type="submit" className="w-full  btn-edit">
                    {t("enregistrer")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

      }

      {ProfileImageModal &&


        <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
          <div className='relative grid grid-cols-1    w-52  rounded-xl'>
            <div className="absolute -top-12 -right-4 p-4">
              <a className='w-12 h-12' onClick={() => { setProfileImageModal(false) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            {
              ProfilePhotoContent != null &&
              <>
                <div className=''>

                  <button className=' w-full sections p-3 font-semibold   rounded-t-lg'>
                    <a className='text-theme'>
                      <label className='flex gap-2 itemx-center justify-start' htmlFor="dropzone-file">

                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                        </svg>

                        {t("Modifier Image")}


                      </label>
                      <input
                        onChange={(e) => AddingProfileImage(e)}
                        id="dropzone-file"
                        type="file"
                        name="image"
                        className="hidden"

                      />
                    </a>
                  </button>

                </div>


                <div className=''>


                  <button onClick={(e) => { DeleteProfileImage(e) }} className='flex  gap-2 w-full sections text-black font-semibold p-3 itemx-center justify-start border-t-2 border-gray-300  rounded-b-lg'>
                    <a className='text-theme'>
                      <label className='flex gap-2 itemx-center justify-start' htmlFor="dropzone-file">

                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                        </svg>
                        {t("Suprimer Image")}
                      </label>
                    </a>
                  </button>
                </div>
              </>
            }

            {
              ProfilePhotoContent == null &&
              <div className=''>

                <button className='  w-full sections p-3  font-semibold   rounded-lg'>
                  <a className='text-theme'>
                    <label className='flex gap-2 itemx-center justify-start' htmlFor="dropzone-file">

                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                      </svg>

                      {t("Ajouter Image")}


                    </label>
                    <input
                      onChange={(e) => AddingProfileImage(e)}
                      id="dropzone-file"
                      type="file"
                      name="image"
                      className="hidden"
                    />
                  </a>
                </button>
              </div>



            }

          </div>
        </div>


      }
      {CoverImageModal &&

        <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
          <div className='relative grid grid-cols-1    w-52  rounded-xl'>
            <div className="absolute -top-12 -right-4 p-4">
              <a className='w-12 h-12' onClick={() => { setCoverImageModal(false) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            {
              CoverPhotoContent != null &&
              <>
                <div className=' '>

                  <button className='w-full sections p-3  font-semibold   rounded-t-lg'>
                    <a className='text-theme'>
                      <label className='flex gap-2 itemx-center justify-start' htmlFor="dropzone-file">

                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                        </svg>

                        {t("Modifier Image")}


                      </label>
                      <input
                        onChange={(e) => AddingCoverImage(e)}

                        id="dropzone-file"
                        type="file"
                        name="image"
                        className="hidden"
                      />
                    </a>
                  </button>
                </div>


                <div className=''>


                  <button onClick={(e) => { DeleteCoverImage(e) }} className='flex  gap-2 w-full sections text-theme font-semibold p-3 itemx-center justify-start border-t-2 border-gray-300  rounded-b-lg'>
                    <a className='text-theme'>
                      <label className='flex gap-2 itemx-center justify-start' htmlFor="dropzone-file">

                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                        </svg>
                        {t("Suprimer Image")}
                      </label>
                    </a>
                  </button>
                </div>
              </>
            }
            {
              CoverPhotoContent == null &&
              <div className=''>

                <button className='  w-full sections p-3  font-semibold   rounded-lg'>
                  <a className='text-theme'>
                    <label className='flex gap-2 itemx-center justify-start' htmlFor="dropzone-file">

                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                      </svg>

                      {t("Ajouter Image")}


                    </label>
                    <input
                      onChange={(e) => AddingCoverImage(e)}

                      id="dropzone-file"
                      type="file"
                      name="image"
                      className="hidden"
                    />
                  </a>
                </button>
              </div>
            }


          </div>
        </div>


      }



      {CropProfileImage &&
        <div>
          <div className="minscreen overflow-auto h-full animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => {
                setCropProfileImage(false); setCroppedImage(null);
                setImageToCrop(null);
                setZoom(1)

              }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full text-about settingswidth p-8">
              <div className="flex flex-col items-left justify-start mt-8">
                <p className="text-md text-gold ">
                  {t("Recadrez votre photo pour un meilleur rendu")}
                </p>
              </div>


              <div className='flex flex-col items-center justify-center p-6'>
                {imageToCrop && (
                  <div className=" crop-container w-full ">
                    <Cropper
                      image={imageToCrop}
                      crop={crop}
                      zoom={zoom}
                      aspect={4 / 4}
                      onCropChange={onCropChange}
                      onZoomChange={onZoomChange}
                      onCropComplete={handleCropComplete}
                    />
                  </div>
                )}
                <div className=" controls">
                  <label for="zoom-input" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Zoom : </label>
                  <input id="zoom-input" type="range"
                    min={1}
                    max={3}
                    step={0.1}
                    value={zoom}
                    onChange={(e) => onZoomChange(parseFloat(e.target.value))}
                    className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none cursor-pointer text-gold" />

                </div>
                {croppedImage && (
                  <div className=" cropped-image-container">
                    <div className="flex flex-col items-left justify-start mt-2 mb-4">
                      <p className="text-md text-gold ">
                        {t("Image Recadrer")}
                      </p>
                    </div>
                    <div className='crop-image'>
                      <img src={URL.createObjectURL(croppedImage)} alt="Cropped" />

                    </div>
                  </div>
                )}
              </div>



              <div>
                <button
                  onClick={(e) => { handleProfileImage(e, croppedImage) }}
                  type="submit"
                  className="w-full btn-edit"
                >
                  {t("enregistrer")}
                </button>
              </div>
            </div>
          </div>
        </div>

      }


      {CropCoverImage &&
        <div>
          <div className="minscreen overflow-auto h-full animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => {
                setCropCoverImage(false); setCroppedImage(null);
                setImageToCrop(null);
                setZoom(1)

              }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full text-about settingswidth p-8">
              <div className="flex flex-col items-left justify-start mt-8">
                <p className="text-md text-gold ">
                  {t("Recadrez votre photo pour un meilleur rendu")}
                </p>
              </div>


              <div className='flex flex-col items-center justify-center p-6'>
                {imageToCrop && (
                  <div className=" crop-container w-full ">
                    <Cropper
                      image={imageToCrop}
                      crop={crop}
                      zoom={zoom}
                      aspect={4 / 3}
                      onCropChange={onCropChange}
                      onZoomChange={onZoomChange}
                      onCropComplete={handleCropComplete}
                    />
                  </div>
                )}
                <div className=" controls">
                  <label for="zoom-input" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Zoom : </label>
                  <input id="zoom-input" type="range"
                    min={1}
                    max={3}
                    step={0.1}
                    value={zoom}
                    onChange={(e) => onZoomChange(parseFloat(e.target.value))}
                    className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none cursor-pointer text-gold" />

                </div>
                {croppedImage && (
                  <div className=" cropped-image-container">
                    <div className="flex flex-col items-left justify-start mt-2 mb-4">
                      <p className="text-md text-gold ">
                        {t("Image Recadrer")}
                      </p>
                    </div>
                    <div className='crop-image'>
                      <img src={URL.createObjectURL(croppedImage)} alt="Cropped" />

                    </div>
                  </div>
                )}
              </div>



              <div>
                <button
                  onClick={(e) => { handleCoverImage(e, croppedImage) }}
                  type="submit"
                  className="w-full btn-edit"
                >
                  {t("enregistrer")}
                </button>
              </div>
            </div>
          </div>
        </div>

      }





    </div>
  )
}

export default ProfileInfoEdit